<template>
  <div class="chartblock">
    <p>{{ $t("BookingOverview.title") }}</p>
    <Doughnut
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="height"
    />
  </div>
</template>

<script>
import { Doughnut } from "vue-chartjs/legacy";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
} from "chart.js";

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale);
export default {
  name: "OccupationChart",
  components: {
    Doughnut,
  },
  props: {
    chartId: {
      type: String,
      default: "doughnut-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Object,
      default: () => {},
    },
    unavailableResources: null,
    resourcesCount: null,
    filterResources: null,
    filterAvailable: null,
  },
  data() {
    return {
      chartData: null,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          tooltip: {
            callbacks: {
              label: (context) => {
                const label = context.label || "";
                const value = context.parsed;
                return label + ": " + value.toFixed(2) + "%";
              },
            },
          },
        },
      },
    };
  },
  watch: {
    unavailableResources: {
      handler: function (newValue) {
        this.generateChartData();
      },
      immediate: true,
    },
    resourcesCount: {
      handler: function (newValue) {
        this.generateChartData(); 
      },
      immediate: true,
    },
  },
  computed: {
    convertToPercent() {
      const occupied = (this.unavailableResources * 100) / this.resourcesCount;
      const unoccupied =
        ((this.resourcesCount - this.unavailableResources) * 100) /
        this.resourcesCount;
      return [unoccupied, occupied];
    },
    getLabels() {
      if (this.filterAvailable === "available") {
        switch (this.filterResources) {
          case "room":
            return [
              this.$t("CenterStats.roomAvailable"),
              this.$t("CenterStats.roomUnavailable"),
            ];
          case "desk":
            return [
              this.$t("CenterStats.deskAvailable"),
              this.$t("CenterStats.deskUnavailable"),
            ];
          case "equipment":
            return [
              this.$t("CenterStats.equipmentAvailable"),
              this.$t("CenterStats.equipmentUnavailable"),
            ];
          default:
            return null;
        }
      } else {
        switch (this.filterResources) {
          case "room":
            return [
              this.$t("CenterStats.roomAvailable"),
              this.$t("CenterStats.bookedRoom"),
            ];
          case "desk":
            return [
              this.$t("CenterStats.deskAvailable"),
              this.$t("CenterStats.bookedDesk"),
            ];
          case "equipment":
            return [
              this.$t("CenterStats.equipmentAvailable"),
              this.$t("CenterStats.bookedEquipment"),
            ];
          default:
            return null;
        }
      }
    },
  },
  methods: {
    generateChartData() {
      this.chartData = {
        labels: this.getLabels,
        datasets: [
          {
            backgroundColor: ["#008000", "#FF0000"],
            data: this.convertToPercent,
          },
        ],
      };
    },
  },
  async created() {
    this.generateChartData();
  },
};
</script>

<style lang="scss" scoped>
.chartblock {
  margin-top: 40px;
  text-align: center;
  justify-content: center;
}
</style>
